import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export const FinalCTA = () => {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-[#F0F5FF] to-[#E7F2FF] relative overflow-hidden" data-id="element-290">
      {/* Dynamic background elements */}
      <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none" data-id="element-291">
        <motion.div className="absolute top-0 left-0 w-[60%] h-[60%] rounded-full bg-gradient-to-br from-[#2E6BFF]/10 to-transparent blur-[100px]" animate={{
        scale: [1, 1.1, 1],
        opacity: [0.2, 0.3, 0.2]
      }} transition={{
        duration: 15,
        repeat: Infinity,
        repeatType: 'reverse',
        ease: 'easeInOut'
      }} data-id="element-292" />
        <motion.div className="absolute bottom-0 right-0 w-[50%] h-[50%] rounded-full bg-gradient-to-tl from-[#36D1DC]/10 to-transparent blur-[80px]" animate={{
        scale: [1, 1.2, 1],
        opacity: [0.2, 0.3, 0.2]
      }} transition={{
        duration: 18,
        repeat: Infinity,
        repeatType: 'reverse',
        ease: 'easeInOut',
        delay: 2
      }} data-id="element-293" />
      </div>
      {/* Cinematic frame markers */}
      <div className="absolute inset-x-0 top-0 h-[1px] bg-[#2E6BFF]/10" data-id="element-294"></div>
      <div className="absolute inset-x-0 bottom-0 h-[1px] bg-[#2E6BFF]/10" data-id="element-295"></div>
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-296">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="bg-white/80 backdrop-blur-sm rounded-2xl p-10 border border-white/50 shadow-[0_20px_80px_rgba(46,107,255,0.1)]" data-id="element-297">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-298">
            <h2 className="text-3xl sm:text-4xl font-bold mb-6 bg-gradient-to-r from-[#0B1220] to-[#2E6BFF] bg-clip-text text-transparent" data-id="element-299">
              Ready to transform your document collection process?
            </h2>
            <p className="text-lg text-[#5A6376] mb-8 max-w-2xl mx-auto" data-id="element-300">
              Join industry leaders who've streamlined their workflows, improved
              client experience, and saved countless hours with Pigeon
              Documents.
            </p>
          </motion.div>
          <motion.div whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} transition={{
          type: 'spring',
          stiffness: 400,
          damping: 17
        }} data-id="element-301">
            <a href="https://calendly.com/pigeondocuments" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 text-base font-medium rounded-full text-white bg-gradient-to-r from-[#2E6BFF] to-[#36D1DC] hover:from-[#2059E2] hover:to-[#32C3CE] transition-all duration-300 shadow-[0_8px_16px_rgba(46,107,255,0.25)]" data-id="element-302">
              Book a Call
              <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-303" />
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>;
};